import React from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setRosterEditNotice } from '../store/conversationSlice';
import { ROSTER_COPY } from '../constants/participantRoster';
import { Alert, AlertDescription } from './ui/alert';
import { Button } from './ui/button';

/**
 * The server refused this user's roster edit (only the bot's owner may make
 * one). A short notice the rep dismisses; cleared with the conversation.
 */
const RosterEditNotice: React.FC = () => {
  const dispatch = useAppDispatch();
  const notice = useAppSelector((state) => state.conversation?.rosterEditNotice ?? null);

  if (!notice) {
    return null;
  }

  return (
    <div className="bg-surface-subtle px-2 pt-2">
      <Alert variant="warning" className="flex items-center justify-between gap-2 px-4 py-2">
        <AlertDescription>{notice}</AlertDescription>
        <Button variant="tertiary" size="sm" onClick={() => dispatch(setRosterEditNotice(null))}>
          {ROSTER_COPY.dismiss}
        </Button>
      </Alert>
    </div>
  );
};

export default RosterEditNotice;
